import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Loader, SelectorDirect, SelectorLogo } from '@klarna/bubble-ui';

const styles = {
  relative: { position: 'relative' },
  center: { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' },
};

const Selector = ({ options, disabled = false, loading = false, ...props }) => {
  const [currentOptions, setCurrentOptions] = useState(options);

  useEffect(() => {
    setCurrentOptions(options.map(option => ({ ...option, disabled })));
  }, [disabled, options]);

  const SelectorComponent = currentOptions.find(({ logoUri }) => !!logoUri)
    ? SelectorLogo
    : SelectorDirect;

  return (
    <div style={styles.relative}>
      {loading && (
        <div style={styles.center}>
          <Loader />
        </div>
      )}
      <SelectorComponent options={currentOptions} {...props} />
    </div>
  );
};

Selector.propTypes = {
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default Selector;
